var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicrosoftDynamics({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0B53CE",
    d: "M15.805 11.322v4.889a2.536 2.536 0 01-1.643 2.374l-1.732.652a.507.507 0 01-.686-.475v-5.956l-3.392 1.239a1.015 1.015 0 00-.664.953v7.986c0 .705.7 1.195 1.363.953l10.161-3.713a2.535 2.535 0 001.666-2.382V7.696a2.537 2.537 0 01-1.666 2.381l-3.407 1.245zm0-.532V9.323a2.537 2.537 0 00-1.645-2.375l-1.728-.65a.508.508 0 00-.686.475v4.59c0 .701-.695 1.191-1.355.956L3.795 9.963a1.015 1.015 0 01-.674-.956V1.015c0-.701.695-1.191 1.356-.955l14.718 5.256A2.538 2.538 0 0120.83 7.21c-.136.861-1.05 2.128-1.79 2.398l-3.235 1.182z"
  })));
}

export default SvgMicrosoftDynamics;